<script>
// import './style.scss' // style in theme plz.
import { onMount } from 'svelte'
import { state } from "./Store/StateStore"
import { config } from "./Store/ConfigStore"

//cmp
import Overlay from "./Component/Overlay.svelte"

//var
export let guarded = [] // elements that are guarded by knowledge of user location

if ( $config.debug ) {
	console.log( { $state } )
	console.log( { $config } )
	console.log( { locations: $config.locations } )
}

// functions
onMount(  () => {

	const eventName = 'cul_guard_item_clicked'

	const handleClickGuardedItem =  e => {
		e.preventDefault()

		const event = new CustomEvent( eventName, {
			detail: { target: e.target }
		} )
		window.dispatchEvent( event )
	}

	const showOverlayForGuardedItem = e => {
		const context = e.detail.target.dataset.guardContext

		if ( ! context ) {
			throw new Error( "showOverlay requires the data-guard-context attribute" )
		}

		state.showOverlay( context )
	}

	// attach
	guarded.forEach( el => el.addEventListener( 'click', handleClickGuardedItem ) )
	window.addEventListener( eventName, showOverlayForGuardedItem )

} )
</script>

{#if $state.overlayVisible}
	<Overlay locations={$config.locations}/>
{/if}

